import { isNativeMobileApp } from 'src/mobile-app/isNativeMobileApp';

export const getAppVersion = () => (isNativeMobileApp() ? window.App?.version : window.appVersion);
